<template>
  <teleport to="body">
    <div
      v-if="isOpen && currentContext"
      class="fixed inset-0 z-[1000] flex items-end justify-end bg-black/30 backdrop-blur-sm"
      @click.self="closeHelp"
    >
      <div
        class="m-5 w-[min(420px,92vw)] rounded-xl bg-light-2 p-5 shadow-lg ring-1 ring-black/5 transition dark:bg-dark-2"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="mb-3 flex items-center justify-between border-b border-black/10 pb-2 dark:border-white/10"
        >
          <h3 class="text-lg font-semibold text-dark-1 dark:text-light-1">
            {{ currentContext.title }}
          </h3>
          <button
            type="button"
            class="flex h-8 w-8 items-center justify-center rounded-full text-xl text-dark-3 hover:bg-light-1 hover:text-dark-1 dark:text-light-3 dark:hover:bg-dark-1 dark:hover:text-light-1"
            @click="closeHelp"
          >
            <em class="mdi mdi-close" />
          </button>
        </div>

        <ul class="flex flex-col gap-2">
          <li v-for="item in currentContext.items" :key="item.id">
            <button
              type="button"
              class="flex w-full items-center justify-between rounded-xl border border-black/5 bg-white/60 px-4 py-3 text-left text-sm font-medium text-dark-2 shadow-sm transition-all hover:bg-primary-2 hover:text-white dark:border-white/10 dark:bg-dark-1 dark:text-light-2 dark:hover:bg-primary-1"
              @click="trigger(item)"
            >
              <span>{{ item.label }}</span>
              <em class="mdi mdi-chevron-right text-lg opacity-60"></em>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { useHelp } from '@/composables/useHelp';

const { isOpen, currentContext, closeHelp, trigger } = useHelp();
</script>
